import { useEffect, useRef } from "react";
import { useFormContext } from "react-hook-form";
import { activeStorageBlobUrl } from "@/react/helpers/urlHelpers";
import { useAttachments } from "@circle-react-shared/BuilderUI/Media/AttachmentContext";
import type { EmojiPickerAddOns } from "@circle-react-uikit/EmojiPickerV3";
import { Form } from "@circle-react-uikit/Form";

export interface ListFieldItemPrefixProps {
  name: string;
}

export interface ListFieldItemPrefixFormProps {
  [key: string]: {
    emoji?: string;
    signed_id?: string | null;
    filename?: string;
    emoji_type?: string;
  };
}

export const EMOJI_RENDERER_TYPES: Record<string, EmojiPickerAddOns> = {
  emoji: "emoji",
  custom: "custom",
};

export const ListFieldItemPrefix = ({ name }: ListFieldItemPrefixProps) => {
  const { watch } = useFormContext<ListFieldItemPrefixFormProps>();
  const { addLocalAttachment } = useAttachments();
  const value = watch(name);

  const prevValueRef = useRef<{
    signed_id?: string | null;
    filename?: string;
  } | null>(null);

  useEffect(() => {
    if (!value?.signed_id || !value?.filename) {
      return;
    }

    if (
      prevValueRef.current?.signed_id === value.signed_id &&
      prevValueRef.current?.filename === value.filename
    ) {
      return;
    }

    const url = activeStorageBlobUrl({
      signed_id: value.signed_id,
      filename: value.filename,
    });

    addLocalAttachment({
      signed_id: value.signed_id,
      url,
    });

    prevValueRef.current = {
      signed_id: value.signed_id,
      filename: value.filename,
    };
  }, [value?.signed_id, value?.filename, addLocalAttachment, name]);

  return (
    <Form.EmojiPickerV3Wrapper
      name={name}
      defaultIcon={null}
      emojiRendererTypes={EMOJI_RENDERER_TYPES}
    />
  );
};
